<template>
  <v-form ref="form" class="">
    
    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-row>

      <v-col cols="12" sm="12" md="6">
        <v-autocomplete
          v-model="entry.sourceStorageId"
          v-bind="getObject('sourceStorageId')"
          label="Estoque de Origem"
          :items="extraData.accountContext.allStorages"
          item-value="id"
          item-text="name"
          :disabled="readOnly"
          autocomplete="off"
        >
          <template v-slot:append-outer>
            <StorageNew
              :inlineAddButton="true"
              @entry-created="sourceStorageCreated"
              modelNameSingular="Estoque de Origem"
            />
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="12" md="6">
        <v-autocomplete
          v-model="entry.targetStorageId"
          v-bind="getObject('targetStorageId')"
          label="Estoque de Destino"
          :items="extraData.accountContext.allStorages"
          item-value="id"
          item-text="name"
          :disabled="readOnly"
          autocomplete="off"
        >
          <template v-slot:append-outer>
            <StorageNew
              :inlineAddButton="true"
              @entry-created="targetStorageCreated"
              modelNameSingular="Estoque de Destino"
            />
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="6" md="4">
        <DateField
          :inputData.sync="entry.transferDate"
          v-bind="getObject('transferDate')"
          label="Data da Transferência"
          :hasTodayButton="true"
          :hasTodayDate="true"
          :disabled="readOnly"
          autocomplete="off"
        />
      </v-col>

      <v-col cols="12" class="" v-if="entry.sourceStorageId">
        <StorageTransferItemsIndex
          :exitMovementItems="entry.exitMovementItemsAttributes"
          :storageTransfer="entry"
          :readOnly="readOnly"
          :isEdit="isEdit"
        />
      </v-col>

      <v-col cols="12">
        <v-textarea
          v-model="entry.observation"
          v-bind="getObject('observation')"
          label="Observações"
          autocomplete="off"
          outlined
          :disabled="readOnly"
        />
      </v-col>

    </v-row>
  </v-form>
</template>

<script>
import MaskedTextField from "@shared_components/masked_text_field.vue"
import DateField from "@shared_components/date_field.vue";
import StorageTransferItemsIndex from "@models/storages/storage_transfers/exit_movement_items/index.vue";
import StorageNew from "@models/storages/new.vue"
import BaseUtil from "@shared_components/base_util.vue";

export default {
  data() {
    return {
      entryAttributes: {},
      pageLoading: false,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: { // utilizado para definir se o form é de edição
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    MaskedTextField: MaskedTextField,
    DateField: DateField,
    StorageTransferItemsIndex: StorageTransferItemsIndex,
    StorageNew: StorageNew,
    BaseUtil: BaseUtil,
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);
  },
  mounted() {
  },
  methods: {
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },
    sourceStorageCreated: function(storage) {
      this.extraData.accountContext.allStorages.unshift(storage);
      this.entry.sourceStorageId = storage.id;
      this.entry.sourceStorage = storage;
    },
    targetStorageCreated: function(storage) {
      this.extraData.accountContext.allStorages.unshift(storage);
      this.entry.targetStorageId = storage.id;
      this.entry.targetStorage = storage;
    },
  }
};
</script>

<style scoped></style>
